<template>
    <div :class="$style.icons">
        <YandexLogo />
    </div>
</template>

<script>
import YandexLogo from "../shapes/YandexLogo";

export default {
    name: "YandexPaymentBlockIcons",
    components: {
        YandexLogo
    }
};
</script>

<style lang="postcss" module>
    .icons {
        display: flex;
        margin-top: 0;
        align-items: center;
    }

    .icons > svg {
        width: 125px;
        height: 55px;
    }

    .icons > svg:not(:last-child) {
        margin-right: 12px;
    }
</style>
